<app-bookshelf-template>
  <ng-template bookshelfTemplateTitle>
    <ng-template #listTitle>
      <div class="d-flex flex-nowrap px-1 bookmarks-title" data-automation-id="bookmarks-title">
        <span class="text-truncate d-block" translate>allAvailable</span>
        &nbsp;
        <div class="w-auto">| {{ !isSearch ? items.length : itemsSearch.length }}</div>
      </div>
    </ng-template>
    <button class="bookmark__header__button bookmark__header__button--title w-100"
            data-automation-id="bookmarks-header-button"
            *ngIf="lists.length > 1; else listTitle"
            (click)="closeList.emit()">
      <fa-icon class="arrow-icon" [icon]="arrowIconLeft"></fa-icon>
      <ng-container *ngTemplateOutlet="listTitle"></ng-container>
    </button>
  </ng-template>

  <ng-container *ngIf="!loading">
    <!-- Select All -->
    <ng-template bookshelfTemplateAction>
      <ng-container *ngIf="!isSearch; else selectAllSearch">
        <button class="bookmark__header__button"
                data-automation-id="bookmarks-action-button-toggle-select-all"
                (click)="setAllItemsSelection('available-list', !isAllSelected)"
                [attr.aria-pressed]="isAllSelected">
                <span class="icon" aria-hidden="true"
                      [ngClass]="isAllSelected ? 'fas fa-check-square' :  'far fa-square'"></span>
          <span translate class="text">bookmarksSelectAll</span>
        </button>
      </ng-container>
      <ng-template #selectAllSearch>
        <button class="bookmark__header__button"
          data-automation-id="bookmarks-action-button-toggle-select-all"
          (click)="setAllItemsSelectionSearch('available-list', !isAllSelectedSearch)"
          [attr.aria-pressed]="isAllSelectedSearch">
          <span class="icon" aria-hidden="true"
                [ngClass]="isAllSelectedSearch ? 'fas fa-check-square' :  'far fa-square'"></span>
          <span translate class="text">bookmarksSelectAll</span>
        </button>
      </ng-template>
    </ng-template>

    <!-- Selection Counter -->
    <ng-template bookshelfTemplateAction>
      <div aria-live="polite" role="status"
           class="d-inline-flex align-items-center h-100 p-2"
           data-automation-id="bookmarks-selection-counter">
        <strong class="text-nowrap">
          {{ 'bookmarksItemsCountSelected' | translate: {itemsCount: !isSearch ? itemsSelectedCount : itemsSelectedCountSearch} }}:
        </strong>
      </div>
    </ng-template>

    <!-- Place Holds -->
    <ng-container *customerFeatureToggle="CustomerFeature.BulkHolds">
      <ng-template bookshelfTemplateAction>
        <button class="bookmark__header__button"
                data-automation-id="bookmarks-action-button-place-holds"
                [disabled]="!itemsSelectedCount"
                (click)="bulkPlaceHolds($event)">
          <fa-icon [icon]="placeHoldsIcon" [classes]="['icon place-holds-icon mr-1']"></fa-icon>
          <span translate class="text">bookmarksPlaceHolds</span>
        </button>
      </ng-template>
    </ng-container>
  </ng-container>

  <!-- Items List -->
  <ng-template bookshelfTemplateBody="ps-short" let-psScroll="psScroll">
    <ng-container *ngIf="!loading; else spinner">
      <div
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollDisabled]="!psScroll || !authorized"
        [infiniteScrollThrottle]="50"
        [infiniteScrollContainer]="psScroll"
        (scrolled)="loadMoreItems()">
        <app-searchable-bookmarks-search-bar
          (search)="onSearch($event)"
          [availableCount]="!isSearch ? availableCount : availableCountSearch"
          [availabilityFilter]="availabilityFilter"
          [lockAvailabilityFilter]="true"
        ></app-searchable-bookmarks-search-bar>
        <app-bookshelf-items-list [bookshelfItems]="!isSearch ? itemsDisplay : itemsSearchDisplay"
          [listId]="'available-list'"
          [ariaLabel]="'bookmarksListItemsListTitle' | translate"
          (onToggleItem)="onToggleItem('available-list', $event)">
        </app-bookshelf-items-list>
      </div>
    </ng-container>
    <ng-template #spinner>
      <div class="d-flex justify-content-center pt-5">
        <div class="spinner-border text-primary"
            style="width: 7rem; height: 7rem;"
            role="status"
            aria-live="polite"
            data-automation-id="available-list-spinner">
          <span class="sr-only" translate>Loading...</span>
        </div>
      </div>
    </ng-template>
  </ng-template>

</app-bookshelf-template>
